import { z } from 'zod';
import { PaymentMethod } from '@/features/orders/types/orders-dto';
import { t } from 'i18next';

const GetOrderItemsListItemSchema = z.object({
  orderItemId: z
    .string(),
  quantity: z
    .number(),
  price: z
    .number(),
})

const ServiceLookupItemSchema = z.object({
  id: z.string({ message: t('elements.form.services.error') }),
  name: z.string().optional(),
  description: z.string().nullish(),
  price: z.number().optional(),
});

export const NewOrderFormSchema = z.object({  
	apartmentId: z
    .array(z.object({
      id: z.string({ message: t('elements.form.apartments.error') }),
      name: z.string().optional()
    })), 
  serviceId: z
    .array(ServiceLookupItemSchema)
    .min(1, { message: t('elements.form.services.error') }),
	date: z
    .date({ message: t('elements.form.date.error') }),
	time: z
    .string({ message: t('elements.form.time.error') }),
  paymentMethod: z
    .nativeEnum(PaymentMethod),
  lines: z
    .array(GetOrderItemsListItemSchema)
    .optional(),  
});

export type NewOrderFormData = z.infer<typeof NewOrderFormSchema>;
